import { useOne } from '@refinedev/core';
import { MarkdownImageCollection } from 'src/company/templates/hooks/useConvertToMarkdownMutation';

type useMarkdownImageCollectionProps = {
  companyId: string;
  collectionId: string;
  enabled?: boolean;
};

export const useMarkdownImageCollection = ({
  companyId,
  collectionId,
  enabled = true,
}: useMarkdownImageCollectionProps) => {
  const { data, isLoading, isError, error, isFetched } = useOne<MarkdownImageCollection>({
    resource: `admin/companies/${companyId}/markdown-image-collections`,
    id: collectionId,
    queryOptions: {
      enabled: enabled,
    },
  });

  return {
    collection: data?.data,
    isLoading,
    isError,
    isFetched,
    error,
  };
};
